// The line that keeps the demo honest, and the way back out of it.
//
// The public demo runs the real Worker, the real reducer and the real components
// against a seeded client, which is the point: what you click is what you get.
// The one thing that is not true of a deployment is that this log is wiped on a
// schedule, so that is the one thing this says, on every screen, without being
// dismissible. A visitor who edits something and comes back tomorrow should have
// been told rather than surprised.
//
// **Leaving is here because a demo should not feel like an account.** It signs you
// in, so there is a session and a name on every row you write, and until this
// existed the only way out was an account menu that reads as something you signed
// up for. One link on the bar that put you here, and you are back on the front
// page with no session.

import { api } from '../lib/api'

export function DemoBar({ contact }: { contact?: string }) {
  async function leave() {
    await api.logout()
    location.assign('/')
  }

  return (
    <div
      className="text-meta flex shrink-0 flex-wrap items-center justify-center gap-x-3 gap-y-0.5 px-3 py-1 text-center"
      style={{ background: 'var(--accent)', color: 'var(--accent-contrast)' }}
    >
      <span>
        This is a demo. Everything here is real except the data, which resets every night.
      </span>
      {contact ? (
        <a className="underline underline-offset-2" href={contact}>
          Get your own
        </a>
      ) : null}
      <button type="button" className="underline underline-offset-2" onClick={() => void leave()}>
        Leave the demo
      </button>
    </div>
  )
}

/** Where "get your own" goes. The demo is the top of the funnel and crum is sold
 *  by talking to someone, not by signing up, so this is the landing page's
 *  contact form rather than a checkout. */
export const DEMO_CONTACT = 'https://crum.saltbark.com/#contact'
